
export type DeferredPromise<T = void> = Promise<T> & {
    resolve: (value?: T | PromiseLike<T>) => void
    reject: (reason?: Error) => void
    pending: boolean
}

export function createDeferredPromise<T = void>(): DeferredPromise<T> {
    let resolveFn: DeferredPromise<T>['resolve']
    let rejectFn: DeferredPromise<T>['reject']
    const promise: any = new Promise<T>((resolve, reject) => {
        resolveFn = resolve
        rejectFn = reject
    })

    promise.pending = true
    promise.resolve = (value: T) => {
        promise.pending = false
        resolveFn(value)
    }
    promise.reject = (reason?: Error) => {
        promise.pending = false
        rejectFn(reason)
    }

    return promise
}
